import {
  ICandidatesAddedByCampaignReport,
  ICandidatesAddedByCampaignTableData,
} from "../../../App/Typings/Reports/CandidatesAddedByCampaign";

/**
 * Generates random table data for a given report
 * @param report
 * @param startDate
 * @param endDate
 */
const generateTableData = (report: ICandidatesAddedByCampaignReport, startDate: Date, endDate: Date) => {
  const startDateCopy = new Date(startDate);

  while (startDateCopy <= endDate) {
    const tableDataPerDay: ICandidatesAddedByCampaignTableData = {
      dateAdded: startDateCopy.toLocaleDateString(),
    };

    //generate random data like: `Campaign1: 123`
    for (const campaign of report.campaignsInReport) {
      const randomCount = Math.floor(Math.random() * 31);
      tableDataPerDay[campaign.name] = randomCount;
      campaign.countInReportPeriod += randomCount;
    }

    report.tableData.push(tableDataPerDay);

    startDateCopy.setDate(startDateCopy.getDate() + 1);
  }
};

/**
 * Creates a report with multiple campaigns. This is primarily used
 * by the Report on the dashboard at the moment.
 * @param startDate
 * @param endDate
 * @returns
 */
const generateMultipleCampaignReport = (startDate: Date, endDate: Date) => {
  const defaultReport: ICandidatesAddedByCampaignReport = {
    campaignsInReport: [
      { name: "Campaign1", countInReportPeriod: 0 },
      { name: "Campaign2", countInReportPeriod: 0 },
      { name: "Campaign3", countInReportPeriod: 0 },
      { name: "Campaign4", countInReportPeriod: 0 },
      { name: "Campaign5", countInReportPeriod: 0 },
      { name: "Campaign6", countInReportPeriod: 0 },
      //We're going to limit display to 6 campaigns so this data is more for testing
      { name: "Campaign7", countInReportPeriod: 0 },
      { name: "Campaign8", countInReportPeriod: 0 },
      { name: "Campaign9", countInReportPeriod: 0 },
      { name: "Campaign10", countInReportPeriod: 0 },
    ],
    tableData: [],
  };

  generateTableData(defaultReport, startDate, endDate);

  return defaultReport;
};

/**
 * Creates a report for a single campaign. This is used on the
 * Campaign Profile page.
 * @param startDate
 * @param endDate
 * @returns
 */
const generateSingleCampaignReport = (startDate: Date, endDate: Date) => {
  const defaultReport: ICandidatesAddedByCampaignReport = {
    campaignsInReport: [{ name: "Campaign1", countInReportPeriod: 0 }],
    tableData: [],
  };

  generateTableData(defaultReport, startDate, endDate);

  return defaultReport;
};

/**
 * Generates demo data for the Candidates Added by Campaign Report
 * @param startDate
 * @param endDate
 * @returns
 */
export const getCandidatesAddedByCampaignDemoData = (startDate: Date, endDate: Date, campaignId?: string) => {
  let report = null;

  if (!campaignId) {
    report = generateMultipleCampaignReport(startDate, endDate);
  } else {
    report = generateSingleCampaignReport(startDate, endDate);
  }

  return report;
};
